import { useEffect, useState } from 'react';
import { t } from '../i18n/index.ts';

type EstadoDaAula = { disciplina?: string; emDirecto?: boolean };

/**
 * Aulas ao vivo (ADR 0030): a porta da disciplina na página inicial. Os
 * estudantes chegam pelo site — e vêem os cursos — em vez de por uma ligação
 * solta para os slides.
 *
 * O nome da disciplina vem do serviço `aulas` (é dado, não código). Se o
 * serviço não responder, ou não tiver disciplina, o bloco não se desenha: é o
 * que acontece em produção enquanto o serviço lá não existir.
 *
 * São ligações normais e não do router: `/aulas` é outra aplicação, servida
 * por outro processo.
 */
export function BlocoDaAula() {
  const [aula, setAula] = useState<EstadoDaAula | null>(null);

  useEffect(() => {
    const controlador = new AbortController();
    fetch('/aulas/api/estado', { signal: controlador.signal })
      .then((r) => (r.ok ? r.json() : null))
      .then((dados: EstadoDaAula | null) => setAula(dados?.disciplina ? dados : null))
      .catch(() => {});
    return () => controlador.abort();
  }, []);

  if (!aula?.disciplina) return null;

  return (
    <section className="aula" aria-labelledby="aula-titulo">
      <p className="aula__etiqueta">
        {aula.emDirecto ? <span className="aula__ponto" aria-hidden="true" /> : null}
        {aula.emDirecto ? t('aula.aDecorrer') : t('aula.etiqueta')}
      </p>
      <h2 className="aula__titulo" id="aula-titulo">
        {aula.disciplina}
      </h2>
      <p className="aula__texto">{t('aula.texto')}</p>
      <div className="aula__accoes">
        <a href="/aulas/" className="btn btn--primary">
          {t('aula.estudante')}
        </a>
        <a href="/aulas/professor/" className="btn btn--secondary">
          {t('aula.professor')}
        </a>
      </div>
    </section>
  );
}
